import { PermissionCategory } from "@/types/permissions.types";
export const PermissionCategories: PermissionCategory[] = [
  {
    id: "dashboard",
    name: "Dashboard",
    permissions: [
      {
        id: "view_dashboard",
        label: "View Dashboard",
        description: "Access main dashboard",
      },
      {
        id: "view_dashboard_analytics",
        label: "View Dashboard Analytics",
        description: "View dashboard analytics and KPIs",
      },
      {
        id: "view_followup",
        label: "View Follow-up",
        description: "View follow-up items and notifications",
      },
      {
        id: "manage_followup",
        label: "Manage Follow-up",
        description: "Create, edit, and manage follow-up tasks",
      },
    ],
  },
  {
    id: "quotes",
    name: "Quote Management",
    permissions: [
      {
        id: "view_quotes",
        label: "View Quotes",
        description: "View all quotes in the system",
      },
      {
        id: "convert_quote_to_order",
        label: "Convert Quote to Order",
        description: "Convert approved quotes to orders",
      },
      {
        id: "manage_quotes_status",
        label: "Manage Quotes Status",
        description: "Change quote status and manage quote lifecycle",
      },
    ],
  },
  {
    id: "orders",
    name: "Order Management",
    permissions: [
      {
        id: "view_orders",
        label: "View Orders",
        description: "View all orders",
      },
      {
        id: "manage_payment_status",
        label: "Manage Payment Status",
        description: "Update and manage order payment status",
      },
      {
        id: "manage_order_status",
        label: "Manage Order Status",
        description: "Change order status and manage order lifecycle",
      },
    ],
  },
  {
    id: "customers",
    name: "Customer Management",
    permissions: [
      {
        id: "view_customers",
        label: "View Customers",
        description: "View customer list and details",
      },
      {
        id: "create_customers",
        label: "Create Customers",
        description: "Add new customers",
      },
      {
        id: "edit_customers",
        label: "Edit Customers",
        description: "Edit customer information",
      },
      {
        id: "delete_customers",
        label: "Delete Customers",
        description: "Delete customer records",
      },
      {
        id: "export_customers",
        label: "Export Customers",
        description: "Export customer data",
      },
    ],
  },
  {
    id: "onboarding",
    name: "Customer Onboarding",
    permissions: [
      {
        id: "view_onboarding",
        label: "View Onboarding",
        description: "View onboarding requests",
      },
      {
        id: "create_onboarding",
        label: "Create Onboarding",
        description: "Create onboarding requests",
      },
      {
        id: "update_user_onboarding",
        label: "Update User Onboarding",
        description: "Update and manage user onboarding status",
      },
    ],
  },
  {
    id: "credit_control",
    name: "Credit Control",
    permissions: [
      {
        id: "view_credit_control",
        label: "View Credit Control",
        description: "Access credit control page",
      },
      {
        id: "manage_credit_limits",
        label: "Manage Credit Limits",
        description: "Set and modify credit limits",
      },
      {
        id: "approve_credit",
        label: "Approve Credit",
        description: "Approve credit applications",
      },
      {
        id: "view_credit_reports",
        label: "View Credit Reports",
        description: "View credit reports and history",
      },
    ],
  },
  {
    id: "product_configurator",
    name: "Product Configurator",
    permissions: [
      {
        id: "view_product_configurator",
        label: "View Product Configurator",
        description: "Access product configurator",
      },
      {
        id: "manage_products",
        label: "Manage Products",
        description: "Add and edit products",
      },
      {
        id: "manage_pricing",
        label: "Manage Pricing",
        description: "Configure product pricing",
      },
      {
        id: "manage_options",
        label: "Manage Options",
        description: "Configure product options",
      },
      {
        id: "manage_product_validation",
        label: "Manage Product Validation",
        description: "Configure and manage product validation rules",
      },
      {
        id: "manage_chatbot_flow",
        label: "Manage Chatbot Flow",
        description: "Configure and manage chatbot conversation flows",
      },
    ],
  },
  {
    id: "analytics",
    name: "Analytics & Reports",
    permissions: [
      {
        id: "view_analytics",
        label: "View Analytics",
        description: "Access analytics page",
      },
    ],
  },
  {
    id: "users",
    name: "User Management",
    permissions: [
      {
        id: "view_users",
        label: "View Users",
        description: "View user directory",
      },
      {
        id: "create_users",
        label: "Create Users",
        description: "Create new user accounts",
      },
      {
        id: "edit_users",
        label: "Edit Users",
        description: "Edit user information",
      },
      {
        id: "deactivate_users",
        label: "Deactivate Users",
        description: "Deactivate user accounts",
      },
      {
        id: "manage_roles",
        label: "Manage Roles",
        description: "Manage user roles and permissions",
      },
      {
        id: "change_region",
        label: "Change Region",
        description: "Change the region for users",
      },
    ],
  },
  {
    id: "settings",
    name: "Settings & Configuration",
    permissions: [
      {
        id: "view_settings",
        label: "View Settings",
        description: "Access settings page",
      },
      {
        id: "view_permissions",
        label: "View Permissions",
        description: "View permissions matrix",
      },
      {
        id: "manage_permissions",
        label: "Manage Permissions",
        description: "Edit role permissions",
      },
    ],
  },
  {
    id: "permission",
    name: "Permission",
    permissions: [
      {
        id: "add_roles",
        label: "Add Roles",
        description: "Create new roles in the system",
      },
      {
        id: "update_roles",
        label: "Update Roles",
        description: "Edit and update existing roles",
      },
      {
        id: "assign_permission_to_role",
        label: "Assign Permission to Role",
        description: "Assign and manage permissions for each role",
      },
    ],
  },
  {
    id: "depots",
    name: "Depot Management",
    permissions: [
      {
        id: "view_depots",
        label: "View Depots",
        description: "View depot list and details",
      },
      {
        id: "manage_depots",
        label: "Manage Depots",
        description: "Add and edit depots",
      },
      {
        id: "assign_depots",
        label: "Assign Depots",
        description: "Assign users to depots",
      },
    ],
  },
  {
    id: "currency_exchange",
    name: "Currency Exchange",
    permissions: [
      {
        id: "view_currency_exchange",
        label: "View Currency Exchange",
        description: "Access currency exchange rates page",
      },
      {
        id: "manage_currency_exchange",
        label: "Manage Currency Exchange",
        description: "Add, edit, and delete currency exchange rates",
      },
    ],
  },
];
